import { render, staticRenderFns } from "./LeftRight.vue?vue&type=template&id=70db23b7&scoped=true&"
import script from "./LeftRight.vue?vue&type=script&lang=js&"
export * from "./LeftRight.vue?vue&type=script&lang=js&"
import style0 from "./LeftRight.vue?vue&type=style&index=0&id=70db23b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db23b7",
  null
  
)

export default component.exports